import React from 'react';
import { Link } from 'react-router-dom';
import Loader from '../../../components/Loader';
import { useUserForm } from '../context/UserFormContext';
import CreateUserHeader from '../create/components/CreateUserHeader';
import UserInformationForm from '../create/components/UserInformationForm';
import RolePermissionsForm from '../create/components/RolePermissionsForm';
export default function UserFormContent() {
  const { canManage, loading, loadError, reload } = useUserForm();
  if (!canManage) return <div className="rounded-xl border bg-white p-6"><h1 className="text-xl font-bold">User Management</h1>
    <p className="my-3 text-sm text-slate-500">Only administrators can create or edit user profiles.</p><Link to="/users" className="text-sm font-semibold text-indigo-600">Back to Users</Link></div>;
  return <><CreateUserHeader />{loading ? <Loader className="py-16" message="Loading user profile..." /> : loadError ?
    <div role="alert" className="rounded-xl border border-red-100 bg-white p-6 text-sm text-red-600">{loadError}<button type="button" onClick={reload} className="ml-3 underline">Retry</button></div> :
    <div className="grid grid-cols-1 items-start gap-6 xl:grid-cols-[minmax(0,2fr)_minmax(280px,1fr)]"><UserInformationForm /><RolePermissionsForm /></div>}</>;
}
